import styled from 'styled-components'

const LoadingStyled = styled.div`
  color: #777;
`

export default LoadingStyled
